import React, { CSSProperties } from 'react';

interface XCircleProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const XCircle: React.FC<XCircleProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
  return (
    <svg 
      className={className}
      height={height} 
      width={width} 
      viewBox="0 0 1060 1060" 
      xmlns="http://www.w3.org/2000/svg" 
      style={style}
    >
      <g fill={fill}>
        <defs/>
        <circle className="cls-1" cx="530" cy="530" fill="none" r="313" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px"/>
        <path className="cls-1" d="M616.27 616.27L443.74 443.74" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px"/>
        <path className="cls-1" d="M443.73 616.27l172.53-172.53" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px"/>
      </g>
    </svg>
  );
};

export default XCircle;
